import React from 'react';

import { flagStyles } from '../settings';

const SvgRW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4560px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRW;
